import Vue from 'vue'
import VueRouter from 'vue-router'
import systemRoutes from './modules/system'
import { refreshToken } from '@/api/system/sys_user'
import {setJwtToken} from "@/lib/utils";
import {setAuthRedirectHandler} from "@/lib/authRedirect";
import store from '@/store/index'

//导入NProgress进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'


Vue.use(VueRouter)

// 解决报错
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [...systemRoutes]
})

// 登录态失效（后端返回 509）时的统一出口：清 token 并回登录页。
// 必须在 router 实例创建之后注册，且由这里（而不是 request.js）决定登录页的名字，
// 这样 request.js 无需 import router，避免循环依赖。
setAuthRedirectHandler(() => {
  setJwtToken('') //清空token
  router.replace({name: 'login'})
})

//从后台动态加载前端路由的时候使用
router.$addRoutes = function (params){
  //router使用matcher来匹配前端路由，如果使用新建的matcher，就相当于清空了之前添加的路由
  router.matcher = new VueRouter().matcher;
  //重新添加路由
  router.addRoutes(params)
}

router.beforeEach((to,from,next) => {
  //console.log(to.name, from.name)
  // 客服相关页面无需登录认证
  const guestRoutes = [
    'login', 'register', 'customer', 'anchor', 'anchorregister', 'forgetpwd',
    'customerServerPc', 'customerServerMobile', 'customerOutLine'
  ];
  if (!guestRoutes.includes(to.name) && !to.query.token) {
    NProgress.start()
    refreshToken().then(res => {
      //没有获得新的token==null，
      // 表示旧的token已经失效，需要重新登录
      if(res.data == null){
        next({name: 'login'}) //去登录界面
        setJwtToken('') //清空token
      }else{//否则去你想去的界面，并把新的token保存起来
        //把全局配置加载完成再去你想去的页面
        store.dispatch('loadSysConfig').then(_ => {
          //console.log(to.name, from.name)
          next()
        })
        setJwtToken(res.data)
      }
    }).catch(() => {
      // refreshToken 失败（含后端返回 509）时也必须放行导航，
      // 否则 next() 永不被调用，路由卡死、进度条一直转
      NProgress.done()
      setJwtToken('') //清空token
      next({name: 'login'}) //去登录界面
    })
  }else{//每次去到登录页面都刷新一下，清除token
    next()
    // 客服页面使用独立的 chat token（?token=查询参数），不应清除 JWT
    // 否则从客服页返回已登录页面时，refreshToken 会因找不到 JWT 而跳转登录页
    const chatRoutes = ['customerServerPc', 'customerServerMobile', 'customerOutLine']
    if (!chatRoutes.includes(to.name)) {
      setJwtToken('') //清空token
    }
  }
})
router.afterEach((to,from) => {
  //console.log(to.name, "afterEach", from.name)
  if(to.name !== 'login'
      && to.name !== 'register'
      && to.name !== 'anchorregister'
      && to.name !== 'forgetpwd'
      && to.name !== 'customerServerPc'
      && to.name !== 'customerServerMobile'
      && to.name !== 'customerOutLine'
      && from.path !== to.path){
    //console.log("afterEach", to.name)
    store.dispatch('addTab',to.path)
  }
  NProgress.done()
})

export default router
